import { useEffect } from "react";

declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}

export default function FbPixel() {
  useEffect(() => {
    const script = document.createElement('script');
    script.innerHTML = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init', '1271831939931284');`;
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
      delete window.fbq;
      delete window._fbq;
    };
  }, []);

  return null;
}

const FbPixelEvent_PageView = () => {
  console.log("Triggered: FB_pixel_Event-PageView");
  window.fbq && window.fbq("track", "PageView");
};

const FbPixelEvent_Lead = () => {
  window.fbq && window.fbq("track", "Lead");
  console.log("Triggered: FB_pixel_Event-Lead");
};

export { FbPixelEvent_Lead, FbPixelEvent_PageView };
